<template>
  <div class="about">
    <TheHeader />
    <main class="main">
      <h3 class="title">Zainteresowania</h3>
      <intersect @intersect.once="showEl">
        <section class="section section--hidden">
          <img
            class="boardgame__img boardgame__img--left"
            src="@/assets/img/anr1.png"
            alt="anr1"
          />
          <p>
            Android Netrunner - od niego wszystsko się zaczęło, więc zasługuje
            na wyróżnienie. Oczywiście wcześniej były małe przygody, chyba
            zwyczajne dla każdego - Eurobiznes (w moim przypadku pod
            płaszczykiem Fortuny) czy inne Chińczyki, ale to było pierwsze,
            poważne wejście w świat planszówek i karcianek. I wow... efekt, a
            oczekiwania...
            <img
              class="boardgame__img boardgame__img--right"
              src="@/assets/img/anr2.png"
              alt="anr2"
            />
            Abstrakcyjność innych tytułów w tym przypadku została pożarta przez
            klimat wyciekający z tego nomen omen niewielkiego gabarytowo (jak to
            zestawy startowe do karcianek) tytułu. Asynchroniczna rozgrywka dla
            2 osób, w której wcielamy się w rolę korporacji broniącej swoich
            tajemnic przed hakerem, który korzystając z wszelkich dostępnych mu
            narzędzi te tajemnice próbuje wykraść. Ciekawostka - autorem jest
            Richard Garfield, twórca znanego Magic The Gathering (którego wersję
            kompyterową MTG Arena, także lubię).
          </p>
        </section>
      </intersect>
      <intersect @intersect.once="showEl">
        <section class="section section--hidden">
          <p>
            Pozostałe planszówki/karcianki - zaczyna brakować miejsca w
            regałąch, mimo raczej ostrej selekcji tytułów. Raczej ameri niż
            euro, istotny klimat, choć ciekawa mechanika może wiele wynagrodzić.
            Warte wzmianki:
          </p>
          <p>
            <img
              class="boardgame__img boardgame__img--left"
              src="@/assets/img/ahc.png"
              alt="Arkham Horror LCG"
            />
            Arkham Horror LCG - idealne połączenie klimatu Lovecrafta z ciekawą
            mechaniką. Scenariusz do rozegrania w jeden wieczór, kampania
            skłądająca się z ok. 8 scenariuszy, w międzyczasie móżdżenie nad
            optymalnym rozwinięciem talii swojej postaci.
          </p>
          <p>
            <img
              class="boardgame__img boardgame__img--right"
              src="@/assets/img/ti.png"
              alt="Twilight Imperium"
            />
            Twilight Imperium - monumentalny tytuł, gra na ok.8h, komputerowe
            tytuły 4X wyglądają przy TI jak młodsi bracia, któzy ejszcze muszą
            sie wiele nauczyć. Ilość gry "nad stołem" tj. nieformalnego
            ukłądania się z innymi graczami, związane z tym sojusze czy zdrady
            powoduje, że czas gry może jeszcze się wydłużyć.
          </p>
          <p>
            <img
              class="boardgame__img boardgame__img--left"
              src="@/assets/img/gloomh.png"
              alt="Gloomhaven"
            />
            Gloomhaven - Kickstarterowy hit ostatnich lat, rpg z ciekwą
            mechaniką, olbrzymią kampanią, którą na szczeście mozną rozgrywać
            partiami (i tu znów idealnie pasującymi do przedziału czasowego -
            dziecko idzie spać - rodzice idą spać)
          </p>
          <p>
            <img
              class="boardgame__img boardgame__img--right"
              src="@/assets/img/bsg.jpg"
              alt="Battlestar Galactica"
            />
            Battlestar Galactica - idelana gra z motywem zdrajcy (tj. z graczem,
            który usiłuje zachować równowage miedzy przeszkadzaniem innym w
            dążeniu do celu, a unikaniem bycia wykrytym/oskarżonym i skazanym
            rpzez resztę).
          </p>
          <p>
            <img
              class="boardgame__img boardgame__img--left"
              src="@/assets/img/fs.webp"
              alt="Forbidden Stars"
            />
            Forbidden Stars - mariaż FFG ze sławnym Games Workshop i ich swiatem
            Warhammera 40K, a to wszystko z piękną mechaniką zakrytych rozkazów.
          </p>
        </section>
      </intersect>
      <intersect @intersect.once="showEl">
        <section class="section section--hidden">
          Opisując planszówki warto wspomnieć o bitewniakach. Tutaj zarówno
          lżejsze tytułu jak X-Wing czy SW Armada, ale też sporo innych, w tym
          kilka od Games Workshop np. Warhammer 40k, Necromunda czy Kill Team.
          Niestety czas nie pozwala wszystkiego przygotować, bo tutaj sama gra
          jest tylko częścią zabawy. Figurki trzeba skleić/złożyć, najlepiej
          pomalować (a najcześciej mają one ok 3cm wysokości), do tego
          przygotowanie terenu. Jakby tego było mało to wszystko po złożeniu
          zaczyna zajmować dość sporo miejsca :D Polecam!
          <div class="bitewniaki">
            <div class="bitewniaki__item bitewniaki__item--1">
              <img
                src="@/assets/img/armada.jpg"
                alt="armada1"
                class="bitewniaki__img"
              />
            </div>
            <div class="bitewniaki__item bitewniaki__item--2">
              <img
                src="@/assets/img/kt_necro.jpg"
                alt="kt1"
                class="bitewniaki__img"
              />
            </div>
            <div class="bitewniaki__item bitewniaki__item--3">
              <img
                src="@/assets/img/kt_orkz.jpg"
                alt="kt2"
                class="bitewniaki__img"
              />
            </div>
            <div class="bitewniaki__item bitewniaki__item--4">
              <img
                src="@/assets/img/kt3.jpg"
                alt="kt5"
                class="bitewniaki__img"
              />
            </div>
            <div class="bitewniaki__item bitewniaki__item--5">
              <img
                src="@/assets/img/necromunda.webp"
                alt="necromunda"
                class="bitewniaki__img"
              />
            </div>
            <div class="bitewniaki__item bitewniaki__item--6">
              <img
                src="@/assets/img/kt1.jpg"
                alt="kt3"
                class="bitewniaki__img"
              />
            </div>
            <div class="bitewniaki__item bitewniaki__item--7">
              <img
                src="@/assets/img/warhammer-40k-miniatures-game-miniatures-image-1.jpg"
                alt="warhammer"
                class="bitewniaki__img"
              />
            </div>
            <div class="bitewniaki__item bitewniaki__item--8">
              <img
                src="@/assets/img/x-wing.jpeg"
                alt="xwing"
                class="bitewniaki__img"
              />
            </div>
          </div>
        </section>
      </intersect>
      <intersect @intersect.once="showEl">
        <section class="section section--hidden">
          Gry komputerowe - od tytułów jak Civilization poprzez FPSy jak
          Borderlands, rpg jak Divinity Original Sin do MMO jak Division czy
          Lineage. Olbrzymie spektrum. Główne kryterium - multiplayer, choć
          niekoniecznie już ze znajomymi (ciężko czasem się zgrać), a z...
          żoną(!), która podziela większość zainteresowań. Tak więc z kryterium
          przesuwamy się w kierunku hotseat czy kooperacji. Lista singli (i
          niestety nie tylko singli) rośnie nieubłaganie.
          <div class="komputerowe">
            <div class="komputerowe__item komputerowe__item--1">
              <img
                src="@/assets/img/Border3_6.jpg"
                alt="Border3_6"
                class="komputerowe__img"
              />
            </div>
            <div class="komputerowe__item komputerowe__item--2">
              <img
                src="@/assets/img/civ6.webp"
                alt="civ6"
                class="komputerowe__img"
              />
            </div>
            <div class="komputerowe__item komputerowe__item--3">
              <img
                src="@/assets/img/divinity.jpg"
                alt="divinity"
                class="komputerowe__img"
              />
            </div>
            <div class="komputerowe__item komputerowe__item--4">
              <img
                src="@/assets/img/division2.webp"
                alt="division2"
                class="komputerowe__img"
              />
            </div>
            <div class="komputerowe__item komputerowe__item--5">
              <img
                src="@/assets/img/lineage2.png"
                alt="l2"
                class="komputerowe__img"
              />
            </div>
          </div>
        </section>
      </intersect>
      <intersect @intersect.once="showEl">
        <section class="section section--hidden">
          Góry - raczej fan alpejskich widoków, ostrych grani i szczytów.
          Niestety lęk wysokości ogranicza nieco drogi mocno eksponowane (choć
          kiedyś sie odważę na Orlą Perć, naprawdę!), ale na chwilę obecną
          większość szlaków w Tatrach Polskich i Słowackich odwiedzona. Cisza i
          spokój szlaku zapewniona wstawaniem o wczesnych godzinach (4-5) i/lub
          nocowaniem w schronisku. Zazwyczaj dopiero schodząc ze szczytów
          spotykasz pierwszych wchodzących, a do tego czasu całe góry ma się
          właściwie dla siebie.
          <div class="gory">
            <div class="gory__item gory__item--1">
              <img src="@/assets/img/g1.jpg" alt="gory1" class="gory__img" />
            </div>
            <div class="gory__item gory__item--2">
              <img src="@/assets/img/g2.jpg" alt="gory2" class="gory__img" />
            </div>
            <div class="gory__item gory__item--3">
              <img src="@/assets/img/g3.jpg" alt="gory3" class="gory__img" />
            </div>
          </div>
        </section>
      </intersect>
    </main>
    <TheFooter />
  </div>
</template>

<script>
import Intersect from '@/components/Intersect.vue';
import TheFooter from '@/components/TheFooter.vue';
import TheHeader from '@/components/TheHeader.vue';
import { onMounted } from '@vue/runtime-core';
export default {
  components: {
    Intersect,
    TheFooter,
    TheHeader,
  },
  setup() {
    const showEl = (entry) => {
      entry.target.classList.remove('section--hidden');
    };
    onMounted(() => {});

    return { showEl };
  },
};
</script>

<style lang="scss">
.about {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(8rem, fit-content) auto minmax(8rem, fit-content);

  img {
    border: 2px solid black;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .section {
    transition: all 1s ease-out;
    padding: 2rem;
    margin-bottom: 10rem;

    font-size: 1.2rem;

    @media (min-width: 55em) {
      font-size: 1.5rem;
    }

    &--hidden {
      opacity: 0;
      transform: translateY(8rem);
    }

    .boardgame__img {
      width: 30%;
      height: 30%;
      padding: 1rem;

      &--right {
        border: none;
        float: right;
      }

      &--left {
        border: none;
        float: left;
      }
    }

    .komputerowe {
      margin-top: 2rem;
      display: grid;
      grid-template-columns: 1fr;
      gap: 2rem;

      @media (min-width: 55em) {
        grid-template-rows: repeat(2, 1fr);
        grid-template-columns: repeat(4, 1fr);

        &__item--1 {
          grid-row: 1/2;
          grid-column: 1/3;
        }
        &__item--2 {
          grid-row: 1/2;
          grid-column: 3/5;
        }
        &__item--3 {
          grid-row: 2/4;
          grid-column: 2/4;
          z-index: 1;
          transform: translate(0, -50%);
        }
        &__item--4 {
          grid-row: 2/3;
          grid-column: 1/3;
        }
        &__item--5 {
          grid-row: 2/3;
          grid-column: 3/5;
        }
      }
    }

    .bitewniaki {
      margin-top: 2rem;
      display: grid;
      grid-template-columns: 1fr;
      gap: 1rem;

      @media (min-width: 55em) {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    .gory {
      margin-top: 2rem;
      display: grid;
      grid-template-columns: 1fr;
      gap: 2rem;

      @media (min-width: 55em) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (min-width: 65em) {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
}
</style>
